module.exports = __webpack_public_path__ + "img/image12.0ac6d993.jpg";